/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */

import React, {
    useCallback,
    useRef,
    useState,
    useContext,
    useEffect
} from 'react';
import { Button, Loader } from '@jutro/components';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { AccountBillingDetailsService } from 'gw-capability-billing';
import { getProxiedUrl } from 'gw-portals-url-js';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import styles from './AuthorizePayment.module.scss';
import messages from './AuthorizePayment.messages';

function AuthorizePayment({
    amountToPay,
    invoiceList,
    isValid,
    billingAddress,
    creditCardFee,
    authHeader,
    history,
    selectPaymentMethod,
    totalAmountToPay,
    feeExemptStates
}) {
    const translator = useContext(TranslatorContext);
    const formRef = useRef();
    const tokenInputRef = useRef();
    const containerRef = useRef(null);
    const isPaymentCompletedRef = useRef(false);

    const [isLoading, setLoadingState] = useState(false);
    const [token, setToken] = useState('NO_TOKEN');

    useEffect(() => {
        console.log(window.location.hostname);

        const $el = window.$(containerRef.current);

        return () => {
            if ($el) {
                $el.off();
            }
        };
    }, [totalAmountToPay]);

    const initEventHandlers = useCallback(($container) => {
        $container.off();

        $container.on('portalOne.paymentComplete', () => {
            isPaymentCompletedRef.current = true;
        });

        $container.on('portalOne.unload', () => {
            if (isPaymentCompletedRef.current) {
                history.push('/home');
            }
        });

        $container.on('portalOne.error', (e, data) => {
            console.error(
                `${new Date()} portalOne.error.`,
                data.Description,
                data.Details
            );
        });
    }, [history]);

    const handlePayment = useCallback(async () => {
        setLoadingState(true);

        try {
            formRef.current.action = getProxiedUrl('/paymentpage');

            const normalizePolicyKey = (policyNumber = '') => {
                return policyNumber.split('(')[0].trim();
            };

            /*
             * feeExemptStates contains the states returned by
             * getNonPSFStates().
             *
             * Therefore, a state in feeExemptStates is treated as
             * a non-PSF state and is eligible for the credit-card fee.
             */
            const isNonPsfInvoice = (invoice) => {
                const invoiceState = _.toUpper(
                    String(
                        _.get(invoice, 'baseState', '')
                    ).trim()
                );

                return (feeExemptStates || []).includes(
                    invoiceState
                );
            };

            const firstInvoice = _.get(invoiceList, '[0]', {});

            const firstPolicyKey = normalizePolicyKey(
                _.get(firstInvoice, 'policyNumber', '')
            );

            const customerId = await AccountBillingDetailsService
                .custumerIDOneInc(
                    firstPolicyKey,
                    authHeader
                );

            const sessionId = await AccountBillingDetailsService
                .sessionIDOneInc(authHeader);

            setLoadingState(false);

            const $container = window.$(containerRef.current);

            $container.portalOne();
            initEventHandlers($container);

            const dialog = $container.data('portalOne');

            const isCreditCard = selectPaymentMethod === 'CC';

            const paymentCategory = isCreditCard
                ? 'CreditCard'
                : 'ECheck';

            /*
             * Use only the amount returned by the credit-card fee API.
             * No default fee amount is applied here.
             */
            const feeAmount = Number(
                _.get(creditCardFee, 'amount', 0)
            ) || 0;

            const invoicesByPolicy = _.groupBy(
                invoiceList,
                (invoice) => normalizePolicyKey(
                    _.get(invoice, 'policyNumber', '')
                )
            );

            const policyEntries = _.map(
                invoicesByPolicy,
                (invoicesForPolicy, policyKey) => {
                    /*
                     * A policy is non-PSF when at least one selected
                     * invoice for that policy belongs to a non-PSF state.
                     */
                    const isNonPsfPolicy = _.some(
                        invoicesForPolicy,
                        isNonPsfInvoice
                    );

                    return {
                        policyKey,
                        invoicesForPolicy,
                        isNonPsfPolicy
                    };
                }
            );

            const hasPsfPolicy = _.some(
                policyEntries,
                (policy) => !policy.isNonPsfPolicy
            );

            const hasNonPsfPolicy = _.some(
                policyEntries,
                (policy) => policy.isNonPsfPolicy
            );

            const isMixedPolicyTransaction = (
                hasPsfPolicy
                && hasNonPsfPolicy
            );

            /*
             * A fee is applicable only for a credit-card payment
             * containing a non-PSF policy and a valid fee amount
             * returned by the fee API.
             */
            const hasActualCreditCardFee = (
                isCreditCard
                && hasNonPsfPolicy
                && feeAmount > 0
            );

            /*
             * The fee is assigned once to the selected non-PSF policy.
             *
             * The normal supported transaction contains one non-PSF
             * policy. Do not assign the fee arbitrarily when multiple
             * non-PSF policies are present.
             */
            const nonPsfPolicies = _.filter(
                policyEntries,
                (policy) => policy.isNonPsfPolicy
            );

            const feeApplicablePolicyKey = hasActualCreditCardFee
                ? _.get(
                    nonPsfPolicies,
                    '[0].policyKey',
                    null
                )
                : null;

            /*
             * PSF only:
             *     PaymentWithFee
             *
             * Non-PSF only:
             *     PaymentWithoutFee
             *
             * PSF plus non-PSF:
             *     PaymentWithoutFee
             */
            const feeContext = (
                hasPsfPolicy
                && !hasNonPsfPolicy
            )
                ? 'PaymentWithFee'
                : 'PaymentWithoutFee';

            const billingZipCode = _.get(
                billingAddress,
                'primaryAddress.postalCode',
                ''
            ) || _.get(firstInvoice, 'billingZip', '');

            const billingZip = billingZipCode
                ? billingZipCode.toString().substring(0, 5)
                : '';

            const policies = _.map(
                policyEntries,
                ({
                    invoicesForPolicy,
                    policyKey,
                    isNonPsfPolicy
                }) => {
                    const isFeeApplicablePolicy = (
                        hasActualCreditCardFee
                        && policyKey === feeApplicablePolicyKey
                    );

                    /*
                     * UPDATED:
                     * The policyholder name is now taken from the
                     * first selected invoice of this policy.
                     */
                    const policyHolderName = _.get(
                        invoicesForPolicy,
                        '[0].policyHolderName',
                        ''
                    );

                    const paymentAmountGroups = invoicesForPolicy.map(
                        (invoice, index) => ({
                            paymentAmountOrder: index + 1,
                            paymentAmountKey: _.get(
                                invoice,
                                'invoiceNumber',
                                ''
                            ),
                            displayName: _.get(
                                invoice,
                                'invoiceNumber',
                                ''
                            ),
                            minimumAmountDue: Number(
                                _.get(
                                    invoice,
                                    'amountDue.amount',
                                    0
                                )
                            ) || 0,
                            otherAmountAllowed: false,
                            isRequired: true,
                            accountGroupCode: 'Default'
                        })
                    );

                    /*
                     * Add the credit-card fee only to the applicable policy.
                     */
                    if (isFeeApplicablePolicy) {
                        paymentAmountGroups.push({
                            paymentAmountOrder:
                                paymentAmountGroups.length + 1,
                            paymentAmountKey: 'Credit Card Fee',
                            displayName: 'Credit Card Fee',
                            minimumAmountDue: feeAmount,
                            otherAmountAllowed: false,
                            isRequired: true,
                            accountGroupCode: 'Default'
                        });
                    }

                    const policyMinAmountDue = Number(
                        _.sumBy(
                            invoicesForPolicy,
                            (invoice) => Number(
                                _.get(
                                    invoice,
                                    'amountDue.amount',
                                    0
                                )
                            ) || 0
                        )
                    ) || 0;

                    const policyAccountBalance = isFeeApplicablePolicy
                        ? policyMinAmountDue + feeAmount
                        : policyMinAmountDue;

                    /*
                     * For a mixed PSF and Non-PSF transaction, every policy
                     * must use PaymentWithoutFee.
                     */
                    const policyFeeContext = isMixedPolicyTransaction
                        ? 'PaymentWithoutFee'
                        : isNonPsfPolicy
                            ? 'PaymentWithoutFee'
                            : 'PaymentWithFee';

                    return {
                        feeContext: policyFeeContext,
                        minAmountDue: policyMinAmountDue,
                        accountBalance: policyAccountBalance,

                        /*
                         * UPDATED:
                         * Policyholder name now comes from the
                         * selected invoice (invoiceList).
                         */
                        policyHolderName,

                        accountGroupCode: `Group${policyKey}`,
                        clientReferenceData1: policyKey,
                        clientReferenceData2: 'GWSM',
                        clientReferenceData5: _.toLower(
                            (process.env.NODE_ENV === 'staging' ? 'stg1' : process.env.NODE_ENV) || 'development'
                        ),

                        isScheduledPayEnabled: false,
                        paymentAmountGroups,

                        accountGroupProtectionSettings: [
                            {
                                accountGroupCode: 'Default',
                                accountGroupProtected: true
                            }
                        ]
                    };
                }
            );

            const makePaymentPayload = {
                operation: 'makePayment',
                paymentCategory,
                amountContext: 'SelectOrEnterAmount',
                billingZip,

                billingAddressStreet: (
                    _.get(
                        billingAddress,
                        'primaryAddress.displayName',
                        ''
                    )
                        || _.get(
                            firstInvoice,
                            'billingAddressStreet',
                            ''
                        )
                )
                    .replace(/\s*\d{5}(?:-\d{4})?$/, '')
                    .trim(),

                confirmationDisplay: true,
                saveOption: 'Save',
                acknowledgmentRequired: true,
                policies,
                feeContext,
                displayMode: 'Modal',
                acceptCreditCards: true,
                paymentMemoMode: 'Disabled',
                acceptPrepaidCards: true,
                loadingIndication: true,
                preventBackgroundScroll: false,

                email: _.get(
                    billingAddress,
                    'emailAddress1',
                    ''
                ),

                customerId,
                sessionId
            };

            console.log('Payment calculation:', {
                feeAmount,
                hasPsfPolicy,
                hasNonPsfPolicy,
                isMixedPolicyTransaction,
                feeApplicablePolicyKey,
                feeContext
            });

            console.log(
                'MakePaymentPayload',
                makePaymentPayload
            );

            dialog.makePayment(makePaymentPayload);
        } catch (err) {
            console.error('Payment API error:', err);
            setLoadingState(false);
        }
    }, [
        authHeader,
        billingAddress,
        creditCardFee,
        feeExemptStates,
        history,
        initEventHandlers,
        invoiceList,
        selectPaymentMethod
    ]);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    return (
        <div>
            <div className={styles.paynowButton}>
                <Button
                    disabled={!isValid}
                    onClick={handlePayment}
                >
                    {translator(messages.payNow)}
                </Button>
            </div>

            <form
                ref={formRef}
                method="post"
            >
                <input
                    type="hidden"
                    ref={tokenInputRef}
                    name="token"
                    value={token}
                />
            </form>

            <div
                id="portalOneContainer"
                ref={containerRef}
            />
        </div>
    );
}

AuthorizePayment.propTypes = {
    amountToPay: PropTypes.shape({}).isRequired,
    totalAmountToPay: PropTypes.number.isRequired,
    invoiceList: PropTypes.arrayOf(
        PropTypes.shape({})
    ).isRequired,
    isValid: PropTypes.bool.isRequired,
    billingAddress: PropTypes.shape({}).isRequired,
    creditCardFee: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
    selectPaymentMethod: PropTypes.string.isRequired,
    feeExemptStates: PropTypes.arrayOf(
        PropTypes.string
    )
};

AuthorizePayment.defaultProps = {
    feeExemptStates: []
};

export default AuthorizePayment;
